













































import { ProgramChain } from "@/data/models/ProgramChain";
import { ProgramChainNote } from "@/data/models/ProgramChainNote";
import { getClientId } from "@/data/repository/ClientRepository";
import { saveProgramChainNote } from "@/data/repository/ProgramChainNotesRepository";
import {
  getActiveUser,
  getActiveUserId,
} from "@/data/repository/UserRepository";
import { generateRandomUuid } from "@/utils/Utils";
import { firestore } from "firebase";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CreateProgramChainNoteComponent extends Vue {
  noteText = "";
  isSavingNote = false;
  showNoteSavedSnackbar = false;

  @Prop()
  programChain!: ProgramChain;

  onAbortNoteCreation() {
    this.$emit("abortNoteCreation");
  }

  async saveNote() {
    if (this.isSavingNote) {
      return;
    }

    const programChain = this.programChain;

    if (!programChain) {
      return;
    }

    const text = this.noteText;

    if (text === "") {
      return;
    }

    this.isSavingNote = true;

    const note: ProgramChainNote = {
      id: generateRandomUuid(),
      programChainId: programChain.id,
      serialNumber: programChain.serialNumber,
      createdAt: firestore.Timestamp.now(),
      createdByClientId: getClientId(),
      createdByUserId: getActiveUserId() as string,
      createdByUserNickname: getActiveUser()?.nickname ?? "",
      noteText: this.noteText,
    };

    await saveProgramChainNote(note);

    this.isSavingNote = false;
    this.showNoteSavedSnackbar = true;

    //Clear old input
    this.noteText = "";
  }
}
